import React from "react";
import { Box, List, ListItem, Button, Paper, useTheme, Typography } from "@mui/material";
import HighlightOffIcon from "@mui/icons-material/HighlightOff";
import { handleIncrementProduct, handleDecrementProduct } from "../helpers/useArticulos";
import AddCircleIcon from "@mui/icons-material/AddCircle";
import RemoveCircleIcon from "@mui/icons-material/RemoveCircle";
import ImagenNotFound from "../images/Imagen_not_found.png";
import LocalGasStationIcon from "@mui/icons-material/LocalGasStation";
import { imgPath } from "../helpers/imgPath";

const ProductoList = ({ productos, handleDeleteRow, updateProducto, estadoDespacho, isScreenWidthLessThan600, isClienteRemito }) => {
  const theme = useTheme();
  return (
    <Paper
      sx={{
        width: 375,
        marginLeft: -2,
        height: isClienteRemito ? 241 : 284,
        overflow: "auto",
        boxShadow: 0,
        marginBottom: 1,
        marginTop: 0.5,
        "&::-webkit-scrollbar": {
          width: "7px",
        },
        "&::-webkit-scrollbar-track": {
          boxShadow: "inset 0 0 5px grey",
          borderRadius: "7px",
        },
        "&::-webkit-scrollbar-thumb": {
          background: "#aaa",
          borderRadius: "7px",
        },
        "&::-webkit-scrollbar-thumb:hover": {
          background: "#888",
        },
      }}
    >
      <List>
        {productos.map(producto => {
          const noEsDespacho = !producto.esDespacho;
          const idProducto = producto.idProducto;
          const imageSource = producto.imagen || imgPath(producto.codigo);
          const imgSrc = imageSource || ImagenNotFound;

          return (
            <ListItem key={producto.idProductoArray} sx={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
              <div style={{ display: "flex", justifyContent: "space-between", flex: 1, alignItems: "center" }}>
                {/* Imagen */}
                {noEsDespacho ? (
                  <img
                    src={imgSrc}
                    alt={producto.descripcion || producto.descripcionArticulo || "Producto"}
                    style={{ width: 40, height: 40, objectFit: "contain", marginRight: 8, borderRadius: 6 }}
                  />
                ) : (
                  <LocalGasStationIcon sx={{ width: 40, height: 40, marginLeft: 0.5, objectFit: "contain", marginRight: 1 }} />
                )}
                <span style={{ textTransform: "uppercase", fontSize: 12 }}>{producto.producto || producto.descripcion || producto.descripcionArticulo}</span>
                <div style={{ marginLeft: "auto", fontSize: 16, ...(!noEsDespacho && { marginRight: "4.5rem" }) }}>{`$${producto.importe.toFixed(2)}`}</div>
              </div>{" "}
              <div style={{ display: "flex", alignItems: "center", marginLeft: "auto", marginLeft: 10, marginRight: 5 }}>
                {noEsDespacho && (
                  <>
                    <RemoveCircleIcon
                      disabled={producto.cantidadArticulo === 1}
                      sx={{ color: producto.cantidadArticulo === 1 ? "darkgray" : theme.bandera.colorSecundario, fontSize: 25, cursor: "pointer" }}
                      onClick={() => {
                        producto.cantidadArticulo !== 1 && handleDecrementProduct(producto.idProductoArray, productos, updateProducto, estadoDespacho);
                      }}
                    />
                    <Typography fontSize={14} sx={{ mx: 1 }}>
                      {producto.cantidadArticulo}
                    </Typography>
                    <AddCircleIcon
                      sx={{ color: theme.bandera.colorSecundario, fontSize: 25, cursor: "pointer" }}
                      onClick={() => handleIncrementProduct(producto.idProductoArray, productos, updateProducto)}
                    />
                  </>
                )}
              </div>
              <Button
                variant="contained"
                sx={{
                  boxShadow: 0,
                  fontWeight: "bold",
                  fontSize: 15,
                  backgroundColor: "transparent",
                  minWidth: "10px !important",
                  width: "10px !important",

                  "&:hover": { backgroundColor: "transparent", boxShadow: "none" },
                }}
                onClick={() => handleDeleteRow(producto.idProductoArray, productos, updateProducto, estadoDespacho)}
              >
                <HighlightOffIcon sx={{ color: "grey", fontSize: 25 }} />
              </Button>
            </ListItem>
          );
        })}
      </List>
    </Paper>
  );
};

export default ProductoList;
